'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Skeleton } from '../../skeleton';

import styles from './List.Skeleton.module.scss';

export type ListSkeletonProps = BaseComponentProps & {
  items: number;
};

function ListSkeleton({ style, className, items }: ListSkeletonProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      {[...Array(items)].map((_, index) => (
        <div className={styles['row']} key={index}>
          <div className={styles['item-wrapper']}>
            <Skeleton className={styles['item']} />
          </div>
          <Skeleton className={styles['legend']} />
        </div>
      ))}
    </div>
  );
}

export { ListSkeleton };
